import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

function hasGroup(groups: string[] | undefined, group: string): boolean {
  return Boolean(groups?.includes(group));
}

/** Route guard — Cognito group ``staff`` required. */
export const RequireStaff: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user, isInitializing } = useAuth();
  if (isInitializing) return null;
  if (!hasGroup(user?.groups, 'staff')) {
    return <Navigate to="/agents" replace />;
  }
  return <>{children}</>;
};

/** Route guard — Cognito group ``super_user`` required. */
export const RequireSuperUser: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user, isInitializing } = useAuth();
  if (isInitializing) return null;
  if (!hasGroup(user?.groups, 'super_user')) {
    return <Navigate to="/agents" replace />;
  }
  return <>{children}</>;
};

export function useIsStaff(): boolean {
  const { user } = useAuth();
  return hasGroup(user?.groups, 'staff');
}

export function useIsSuperUser(): boolean {
  const { user } = useAuth();
  return hasGroup(user?.groups, 'super_user');
}
